import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onRefreshAdmin: () => void;
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    marginRight: 30,
  },
  personActions: {
    display: 'flex',
  },
}));

export const AdminHeader: React.FC<Props> = ({ onRefreshAdmin }) => {
  const classes = useStyles();
  const { t } = useTranslation('admin');

  useEffect(() => {
    onRefreshAdmin();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.root}>
      <Typography variant="h4" component="h4">
        {t('header.title')}
      </Typography>

      <Box className={classes.personActions}>
        <Tooltip title={t('header.refreshTooltip')}>
          <IconButton
            aria-label="refresh"
            size="large"
            onClick={onRefreshAdmin}
          >
            <RefreshIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      </Box>
    </div>
  );
};

export default AdminHeader;
